import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import {FrapperService} from "./frapper.service";
import {AssignedService} from "./assigned.service";
import { AuthService } from '../auth/auth.service';

@Injectable({
  providedIn: 'root'
})
export class RecoursService {

  Doctype_recours ='Recours'
  Doctype_Type_Demande ='type_de_demande'

  constructor(private http: HttpClient, private frapper: FrapperService,private authservice: AuthService, private assigneService:AssignedService) {}


 //all recours
  async getAllRecours(filter =null) {
    try {
      let all_recours = await this.frapper.GetDoctypes(this.Doctype_recours,'["*"]',filter).toPromise()
      console.log('resp api Doctype_Signature ===> ', all_recours)
      return all_recours
    } catch (error) {
      this.authservice.handleError(error)
    }

  }


  async getOneRecour(name) {
    try {
      let recours = await this.frapper.GetDoctype(this.Doctype_recours,name,'["*"]',null).toPromise()
    //console.log('My Courriers Principale ===> ', my_courriers)
    return recours
    } catch (error) {
      this.authservice.handleError(error)
    }

  }

  async nouvelleRecours(body) {
    try {
      let recours = await this.frapper.CreateDoctype(this.Doctype_recours,body).toPromise()
      return recours
    } catch (error) {
      this.authservice.handleError(error)
    }

  }

  async updateRecours(docname,body){
    try {
      let result = this.frapper.UpdateDoctype(this.Doctype_recours,docname,body).toPromise()
      return result
    } catch (error) {
      this.authservice.handleError(error)
    }

  }

  async updateSatate(docname,new_state){
    try {
      let body= {
        "workflow_state": new_state
      }
      let result = this.frapper.UpdateDoctype(this.Doctype_recours,docname,body).toPromise()
      return result
    } catch (error) {
      this.authservice.handleError(error)
    }

  }

 // ** Demande

}
